// create an autocomplete search field from the search input using wordpress rest api to get the results
// /wp-json/wp/v2/product?search=SEARCHTERM

(function($) {

  function debounce(func, wait, immediate) {
    var timeout
    return function() {
      var context = this,
        args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(function() {
        timeout = null
        if (!immediate) func.apply(context, args)
      }, wait)
      if (immediate && !timeout) func.apply(context, args)
    }
  }

  const $searchField = $('#search-field')
  const $hits = $('#hits')
  const $form = $('#search-form')
  const $formWrapper = $('.product-search-wrapper')
  let $request
  let activeItemIndex = -1;
  let activeSearch = '';
  if (window.ajax.search_url === undefined || window.ajax.search_url === '') {
    window.ajax.search_url = '/?post_type=product'; // default search url
  }
  if (window.ajax.search_noresults === undefined || window.ajax.search_noresults === '') {
    window.ajax.search_noresults = 'No results'; // default search url
  }
  if (window.ajax.search_allesults === undefined || window.ajax.search_allesults === '') {
    window.ajax.search_allesults = 'All results'; // default search url
  }

  const search = function() {
    const search = $searchField.val()
    if (search.length < 3) {
      return
    }
    // if search term is the same as last time, don't do anything
    if (search === activeSearch) {
      return
    }
    // abort pending requests
    if ($request != null) {
      $request.abort()
      $request = null
    }

    //is window.ajax.search_rest  is undefined or empty, don't do anything
    if (window.ajax.search_rest === undefined || window.ajax.search_rest === '') {
      return
    }

    $formWrapper.addClass('loading')

    activeSearch = search
    const url = window.ajax.search_rest + '?per_page=20&search=' + search
    $request = $.get(url, function(data) {
      $hits.empty()
      if (data.length === 0) {
        $hits.append('<li class="hits__item"><div class="hits__content hits__nocontent">' + window.ajax.search_noresults +'</div></li>')
        $formWrapper.removeClass('loading')
        return
      }
      data.forEach(function(item) {

        const $li = $('<li id="product-'+ item.id +'" class="hits__item" data-seo-container></li>')
        const $div = $('<div class="hits__content"></div>')

        if (item.product_image) {
          $li.append('<img loading="lazy" class="hits__img" src="' + item.product_image + '" alt="' + item.title.rendered + '" width="32" heigh="32" />')
        } else {
          $li.append('<div class="hits__img"></div>')
        }

        $div.append('<a href="' + item.link + '" class="hits__title" data-seo-target>' + item.title.rendered + '</a>')

        if (item.product_price_range) {
          $div.append('<span class="hits__price">' + item.product_price_range + '</span>')
        }
        $li.append($div)
        $hits.append($li)
      })
      $hits.append('<li class="hits__item"><div class="hits__content hits__nocontent"><a href="'+ window.ajax.search_url + '&s=' + $searchField.val() +'">' +  window.ajax.search_allesults  +'</a></div></li>')
      // scroll top
      $hits.scrollTop(0)
      $hits.show()
      $formWrapper.removeClass('loading')
    })
  }

  function hit_selected (index){
    const $selected = $hits.find('li').eq(index)
    if ($selected.length === 0) {
      return
    }
    $hits.find('li').removeClass('hits__selected').removeAttr('aria-selected');
    $selected.addClass('hits__selected').attr('aria-selected', 'true');
    $searchField.attr('aria-activedescendant', $selected.attr('id'));
    // scroll animate to selected item
    $hits.stop().animate({
      scrollTop: $hits.scrollTop() + $selected.position().top
    }, 100);
  }

  function hit_hide(){
    $hits.hide()
    $hits.find('li').removeClass('hits__selected').removeAttr('aria-selected');
    $searchField.removeAttr('aria-activedescendant');
  }

  $form.on('submit', function(e) {
    e.preventDefault()
    const $selected = $hits.find('.hits__selected')
    if ($selected && $selected.length > 0) {
      window.location.href = $hits.find('.hits__selected a').attr('href')
    } else {
      window.location.href = window.ajax.search_url + '&s=' + $searchField.val()
    }
  })

  $searchField
    .on('keyup', debounce(search, 500))
    .on('keydown', function(e) {
      //if esc key is pressed hide $hits
      if (e.keyCode == 27) {
        e.preventDefault()
        hit_hide()
      }
      //if is arrow down key select next item in $hits
      if (e.keyCode == 40) {
        e.preventDefault()
        if (activeItemIndex < $hits.find('li').length - 1) {
          activeItemIndex++
        }
        hit_selected(activeItemIndex)
      }
      //if is arrow up key select previous item in $hits
      if (e.keyCode == 38) {
        e.preventDefault()
        if (activeItemIndex > 0) {
          activeItemIndex--
        }
        hit_selected(activeItemIndex)
      }
    })
    .on('focus', function() {
      if ($hits.find('li').length === 0) {
        return
      }
      $hits.show()
    })
    .on('blur', function() {
      setTimeout(function() {
        hit_hide()
      }, 500)
    })
})(jQuery)
